/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientFavoriteClinicTypename = "PatientFavoriteClinic" as const;

/**
 *
 * @export
 * @interface PatientFavoriteClinic
 */
export interface PatientFavoriteClinic {
  /**
   *
   * @type {Array<number>}
   * @memberof PatientFavoriteClinic
   */
  favoriteClinics?: Array<number>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientFavoriteClinic
   */
  readonly __typename?: string;
}

export function PatientFavoriteClinicFromJSON(json: any): PatientFavoriteClinic {
  return PatientFavoriteClinicFromJSONTyped(json, false);
}

export function PatientFavoriteClinicFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientFavoriteClinic {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientFavoriteClinicTypename,

    favoriteClinics: !exists(json, "favorite_clinics") ? undefined : json["favorite_clinics"],
  };
}

export function PatientFavoriteClinicToJSON(object?: PatientFavoriteClinic | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    favorite_clinics: value.favoriteClinics,
  };
}
